import { ComplianceInterface } from '@app/containers/compliance/compliance.config';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStore } from '@app/store/auth.store';

@Injectable()
export class ComplianceInterceptor implements HttpInterceptor {
    private authStore = inject(AuthStore);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const compliances = this.authStore.userCompliances();
        if (!compliances) {
            return next.handle(request);
        }
        request = this.setCompliances(compliances, request);
        return next.handle(request);
    }

    private setCompliances(compliances: ComplianceInterface, request: HttpRequest<any>): HttpRequest<any> {
        request = request.clone({
            headers: request.headers
                .set('dmf', compliances.dmf)
                .set('dppa', compliances.dppa)
                .set('glba', compliances.glba),
        });
        return request;
    }
}
